import TextField from '@atlaskit/textfield';
import { ANALYTICS_ACTION_CLICKED, ANALYTICS_SUBJECT_BUTTON, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { usePartnerPermissions } from '@atlassian/mpac-ui';
import React, { useState } from 'react';
import TabHeader from "../../../../common/components/Tabs/TabHeader";
import { usePartnerDetails } from "../../../../common/hooks.js";
import { CREATE_APP, MANAGE_PARTNER_APPS_VIEW } from "../../../analytics/Events";
import { usePartnerApps } from "./hooks/hooks";
import NoAppsView from "./NoAppsView";
import PartnerAppsTable from "./PartnerAppsTable";

const PartnerApps = ({
  partnerId,
  mpacBaseUrl
}) => {
  const showLoyaltyDiscountRow = true;
  const {
    partnerDetails
  } = usePartnerDetails(mpacBaseUrl, partnerId);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchQuery, setSearchQuery] = useState(null);
  const [searchText, setSearchText] = useState(''); // offset in which the paginated results should start from (for ex: 0, 10, 20)

  const {
    partnerApps,
    pending,
    error
  } = usePartnerApps(mpacBaseUrl, partnerId, (pageNumber - 1) * 10, searchQuery);
  const partnerPermissions = usePartnerPermissions();
  const fireAnalyticsEvent = useAnalyticsEvents();

  const handleSearchTextChange = event => {
    const search = event.target.value.trim();
    setSearchText(search);
  };

  const handleSearch = e => {
    e.preventDefault();
    setPageNumber(1);
    setSearchQuery(searchText);
  };

  const onCreateAppClick = analyticsActionSubject => {
    fireAnalyticsEvent({
      eventContainer: MANAGE_PARTNER_APPS_VIEW,
      action: ANALYTICS_ACTION_CLICKED,
      actionSubject: analyticsActionSubject,
      actionSubjectId: CREATE_APP
    });
    window.location.href = '/manage/apps/create';
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Apps",
    ctaText: partnerPermissions !== null && partnerPermissions !== void 0 && partnerPermissions.canManagePartnerDetails ? 'Create app' : '',
    onCTAClick: () => onCreateAppClick(ANALYTICS_SUBJECT_BUTTON)
  }), partnerApps && partnerApps.count === 0 && partnerDetails && !searchQuery && !pending ? /*#__PURE__*/React.createElement(NoAppsView, {
    partnerDetails: partnerDetails,
    canManagePartnerDetails: partnerPermissions === null || partnerPermissions === void 0 ? void 0 : partnerPermissions.canManagePartnerDetails,
    onCreateAppClick: onCreateAppClick
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSearch
  }, /*#__PURE__*/React.createElement(TextField, {
    placeholder: "Search for apps",
    width: "large",
    onChange: handleSearchTextChange
  })), /*#__PURE__*/React.createElement(PartnerAppsTable, {
    partnerApps: partnerApps,
    showLoyaltyDiscountRow: showLoyaltyDiscountRow,
    pending: pending,
    error: !!error,
    pageNumber: pageNumber,
    setPageNumber: setPageNumber
  })));
};

export default PartnerApps;